// Адрес витрины покупателя для ссылок «Открыть на витрине» и товаров идей.
//
// Раньше консоль брала общий storefrontOrigin() из ui-primitives: «адрес
// консоли без admin.». На проде консоль живёт на admin-3jga8.osmix.ru, правило
// не срабатывало, и ссылка уходила на admin-3jga8.osmix.ru/product/… - страницу
// «не найдено» самой консоли (проверка кликов 20.10.2026, № 4-9). Порядок тот
// же, что у кабинета продавца (apps/seller-web/lib/storefront.ts):
//
// 1. BUN_PUBLIC_STOREFRONT_URL - явный адрес (вшивается при сборке, как адрес API).
// 2. Соседний с API хост: api.osmix.ru → web.osmix.ru (адрес API вшит всегда).
// 3. Соседний с консолью: admin.X и admin-<что угодно>.X → web.X.
// 4. Иначе - основная витрина.
import { storefrontProductPath } from "@osmix/ui-primitives/idea-editor";

/** Витрина покупателя на проде. */
export const DEFAULT_STOREFRONT = "https://web.osmix.ru";

// Bun подставляет process.env.BUN_PUBLIC_* литералом; если переменная не
// задана, обращение к process в браузере бросает - это значит «не задано».
// Подробно - в api/client.ts.
const readEnv = (read: () => string | undefined): string | undefined => {
	try {
		return read();
	} catch {
		return undefined;
	}
};

export const resolveStorefrontOrigin = ({
	explicit,
	apiUrl,
	origin,
}: {
	explicit?: string;
	apiUrl?: string;
	origin?: string;
}): string => {
	if (explicit?.trim()) return explicit.trim().replace(/\/+$/, "");
	for (const [raw, prefix] of [
		[apiUrl, /^api\./],
		[origin, /^admin(?:-[^.]+)?\./],
	] as const) {
		if (!raw) continue;
		try {
			const url = new URL(raw);
			if (prefix.test(url.hostname)) {
				return `${url.protocol}//${url.hostname.replace(prefix, "web.")}`;
			}
		} catch {
			// Неразборчивый адрес - идём дальше.
		}
	}
	return DEFAULT_STOREFRONT;
};

export const storefrontBase = (): string =>
	resolveStorefrontOrigin({
		explicit: readEnv(() => process.env.BUN_PUBLIC_STOREFRONT_URL),
		apiUrl: readEnv(() => process.env.BUN_PUBLIC_API_GATEWAY_URL),
		origin: typeof window === "undefined" ? undefined : window.location.origin,
	});

/** Карточка товара на витрине (открывать в новой вкладке). */
export const storefrontProductUrl = (productId: string): string =>
	`${storefrontBase()}${storefrontProductPath(productId)}`;
